export function getLaunchDelay(state) {
    return state.launchDelay
}

export function getAutoLaunchOnLogin(state) {
    return state.autoLaunchOnLogin
}

export function getAutoLaunchOnStartup(state) {
    return state.autoLaunchOnStartup
}

export function getLayout(state) {
    return state.layout
}

export function getUiSettings(state) {
    return {
        launchDelay: state.launchDelay,
        autoLaunchOnLogin: state.autoLaunchOnLogin,
        autoLaunchOnStartup: state.autoLaunchOnStartup,
        layout: state.layout,
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/ui/selectors.js